import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { faXmark } from '@fortawesome/free-solid-svg-icons'
export default function Popup(props: any) {

    let showCloseButton = true;

    if (props.hideCloseButton) {
        showCloseButton = false;
    }

    return (
        <div className="popup-box">
            <div className="box">
                {showCloseButton && 
                    <div className="close-icon" onClick={props.handleClose}><FontAwesomeIcon icon={faXmark} /></div>
                }
                <div className="popup-content">
                    {props.content}
                </div>
            </div>
        </div>
    );
};